document.addEventListener('DOMContentLoaded', () => {
    initProjektyGrid();
});

function initProjektyGrid() {
    const gridContainer = document.querySelector('.projekty-grid');
    if (!gridContainer) return;

    // Nejprve navěsit listenery
    initGridFiltering(gridContainer);
    initLoadMore(gridContainer);

    // Pak teprve použít filtr z URL (listenery už existují)
    applyFilterFromURL(gridContainer);
}

function applyFilterFromURL(container) {
    const params = new URLSearchParams(window.location.search);
    const category = params.get('category');

    if (!category) return;

    // zkusíme najít exact match
    let button = container.querySelector(`.projekty-category-button[data-category="${category}"]`);

    // fallback na "all", pokud neexistuje požadovaná kategorie
    if (!button) {
        button = container.querySelector(`.projekty-category-button[data-category="all"]`);
    }

    if (button) {
        button.click(); // spustí stávající logiku filtrování
    }
}

function initGridFiltering(container) {
    const loader = container.querySelector('#projekty-grid-loader');
    const itemsContainer = container.querySelector('#projekty-grid-container');
    if (!itemsContainer) return;

    const allItems = Array.from(itemsContainer.querySelectorAll('.projekty-grid-item'));
    const categoryButtons = container.querySelectorAll('.projekty-category-button');
    if (!categoryButtons.length) return;

    categoryButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (loader) loader.classList.remove('hidden-x');

            // Aktivní stav
            categoryButtons.forEach(b => b.classList.remove('filter-active'));
            button.classList.add('filter-active');

            // Kategorie z tlačítka
            const cat = button.getAttribute('data-category');

            // ✅ Aktualizace URL bez reloadu (bez zbytečného otazníku)
            const params = new URLSearchParams(window.location.search);
            if (cat === 'all') {
                params.delete('category');
            } else {
                params.set('category', cat);
            }
            const query = params.toString();
            const newUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;
            window.history.replaceState({}, '', newUrl);

            setTimeout(() => {
                let visibleCount = 0;

                // Zobrazit/skrýt podle kategorie
                allItems.forEach(item => {
                    const dataCats = item.getAttribute('data-categories');
                    const cats = dataCats ? dataCats.split(',').map(tag => tag.trim()) : [];

                    if (cat === 'all' || cats.includes(cat)) {
                        if (visibleCount < 12) {
                            item.classList.remove('hidden-x');
                            visibleCount++;
                        } else {
                            item.classList.add('hidden-x');
                        }
                    } else {
                        item.classList.add('hidden-x');
                    }
                });

                // Reset Load More
                const loadMoreButton = container.querySelector('#load-more-button');
                if (loadMoreButton) {
                    loadMoreButton.setAttribute('data-visible', '3');
                    loadMoreButton.classList.remove('hidden-x');
                }

                // Schovat View All
                const viewAllButton = container.querySelector('#view-all-button');
                if (viewAllButton) {
                    viewAllButton.classList.add('hidden-x');
                }

                if (loader) loader.classList.add('hidden-x');
            }, 300);
        });
    });
}

function initLoadMore(container) {
    const loadMoreButton = container.querySelector('#load-more-button');
    if (!loadMoreButton) return;

    const viewAllButton = container.querySelector('#view-all-button');
    const itemsContainer = container.querySelector('#projekty-grid-container');
    if (!itemsContainer) return;

    loadMoreButton.addEventListener('click', () => {
        const loader = container.querySelector('#projekty-grid-loader');
        if (loader) loader.classList.remove('hidden-x');

        setTimeout(() => {
            // Stav
            let visible = parseInt(loadMoreButton.getAttribute('data-visible'), 10);
            const increment = parseInt(loadMoreButton.getAttribute('data-increment'), 10);

            // Aktivní kategorie
            const activeButton = container.querySelector('.projekty-category-button.filter-active');
            const cat = activeButton ? activeButton.getAttribute('data-category') : 'all';

            // Položky v kategorii
            const allItems = Array.from(itemsContainer.querySelectorAll('.projekty-grid-item'));
            const categoryItems = allItems.filter(item => {
                if (cat === 'all') return true;
                const dataCats = item.getAttribute('data-categories');
                const cats = dataCats ? dataCats.split(',').map(tag => tag.trim()) : [];
                return cats.includes(cat);
            });

            // Další dávka
            let newVisible = Math.min(visible + increment, categoryItems.length);

            for (let i = visible; i < newVisible; i++) {
                categoryItems[i]?.classList.remove('hidden-x');
            }

            // Update počitadla
            loadMoreButton.setAttribute('data-visible', newVisible.toString());

            // Konec seznamu → schovat Load More, ukázat View All
            if (newVisible >= categoryItems.length) {
                loadMoreButton.classList.add('hidden-x');
                if (viewAllButton) viewAllButton.classList.remove('hidden-x');
            }

            if (loader) loader.classList.add('hidden-x');
        }, 300);
    });
}
